import { render, staticRenderFns } from "./serviceTooltip.vue?vue&type=template&id=b11d1d54&scoped=true&lang=pug&"
import script from "./serviceTooltip.vue?vue&type=script&setup=true&lang=js&"
export * from "./serviceTooltip.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./serviceTooltip.vue?vue&type=style&index=0&id=b11d1d54&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b11d1d54",
  null
  
)

export default component.exports